<template>
  <div>
    <v-sheet class="text-center py-16">
      <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
      <p class="mt-4 text-caption">Google 로그인중</p>
    </v-sheet>

    <!-- SNS 로그인 신규 가입 dialog -->
    <v-dialog max-width="540" v-model="show_confirm_dialog" content-class="rounded-10" style="z-index: 999">
      <v-sheet class="rounded-10 pa-4">
        <p class="text-center mb-0">
          <v-icon size="80" color="#f2b8bf" class="">mdi-alert-circle-outline</v-icon>
        </p>

        <p class="text-center text-body mt-3 px-1" style="letter-spacing: 0px !important" v-html="$t('page.login.alert-info-new-member-guide')"></p>

        <div class="d-flex justify-space-between mt-6">
          <v-btn color="#ddd" class="rounded-10" dark width="48%" depressed @click="loginCancle()"> {{ $t("button.no") }} </v-btn>

          <v-btn color="#f2b8bf" class="rounded-10" dark width="48%" depressed @click="next_register()"> {{ $t("button.yes") }} </v-btn>
        </div>
      </v-sheet>
    </v-dialog>
    <v-dialog max-width="540" v-model="show_warn_dialog" content-class="rounded-10" style="z-index: 999">
      <v-sheet class="rounded-10 pa-4">
        <p class="text-center mb-0">
          <v-icon size="80" color="#f2b8bf" class="">mdi-alert-circle-outline</v-icon>
        </p>

        <p class="text-center text-body mt-3 px-1" style="letter-spacing: 0px !important">
          {{ warn_error_message }}
        </p>

        <div class="d-flex justify-center mt-6">
          <v-btn color="#f2b8bf" class="rounded-10" dark width="48%" depressed @click="loginCancle()"> {{ $t("button.ok") }} </v-btn>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex"
import authService from "@/api/auth-service"
const { createTravelerLoginDestination } = require("@/util/travelerAttribution")

export default {
  data() {
    return {
      show_confirm_dialog: false,
      warn_error_message: "",
    }
  },

  computed: {
    show_warn_dialog: {
      get() {
        return !!this.warn_error_message
      },
      set(value) {
        if (!value) {
          this.warn_error_message = ""
        }
      },
    },
  },
  mounted() {
    this.googleLogin()
  },

  methods: {
    ...mapMutations(["ADD_TEMP_SNS_USER"]),
    ...mapActions(["login"]),

    async googleLogin() {
      const formData = new URLSearchParams()
      const redirectUri = window.location.origin + process.env.VUE_APP_GOOGLE_REDIRECT_URI
      formData.append("code", this.$route.query.code)
      formData.append("client_id", process.env.VUE_APP_GOOGLE_CLIENT_ID)
      formData.append("client_secret", process.env.VUE_APP_GOOGLE_SECRET)
      formData.append("redirect_uri", window.location.origin + process.env.VUE_APP_GOOGLE_REDIRECT_URI)
      formData.append("grant_type", "authorization_code")

      try {
        // 구글 API 호출 시에는 withCredentials를 false로 설정
        const axios = require("axios")
        const tokenRes = await axios.post("https://oauth2.googleapis.com/token", formData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          withCredentials: false, // CORS 에러 방지
        })
        const userResp = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${tokenRes.data.access_token}`,
          },
          withCredentials: false, // CORS 에러 방지
        })
        if (userResp.data) {
          const email = userResp.data.email
          let state = null
          if (this.$route.query.state) {
            state = JSON.parse(decodeURIComponent(atob(this.$route.query.state)))
          }
          // console.log(userResp)
          // 만약 기존에 구글로그인한 계정이 있다면
          let user = await authService.checkDuplicateEmail(email)
          if (!user) {
            // 회원정보가 없음.
            console.log("회원정보가 없음.")
            user = {
              user_id: userResp.data.email,
              //password: userResp.data.sub,
              name: userResp.data.name,
              profile_image: userResp.data.picture,
              //phone: "SNS 로그인",
              //email: userResp.data.email,
              sns_id: userResp.data.sub,
              provider_type: "google",
            }
            this.ADD_TEMP_SNS_USER(user)
            // show popup
            this.show_confirm_dialog = true
          } else {
            // 회원정보가 있음. 있다면, 내꺼인지 확인을 해야함.
            if (/* user.sns_id == userResp.data.sub && */ user.provider_type === "google") {
              // 기존 SNS 사용자 정보 업데이트
              try {
                user = {
                  ...user,
                  name: userResp.data.name,
                  sns_id: userResp.data.sub,
                  provider_type: "google",
                }
                await authService.updateSnsUserInfo(user)
              } catch (e) {
                console.log(e)
              }
            } else if (user.phone === "SNS 로그인") {
              //DB 이전의 호환을 위해서
              try {
                user = {
                  ...user,
                  name: userResp.data.name,
                  sns_id: userResp.data.sub,
                  provider_type: "google",
                }
                await authService.updateSnsUserInfo(user)
              } catch (e) {
                console.log(e)
              }
            } else {
              // 이미 가입된 계정안내
              // show POPUP
              let prefix = "이메일 회원으로 가입된 계정입니다. "
              switch (user.provider_type.toLowerCase()) {
                case "kakao":
                  prefix = "카카오 계정으로 가입된 계정입니다. "
                  break
                case "naver":
                  prefix = "네이버 계정으로 가입된 계정입니다. "
                  break
                default:
                  break
              }
              this.warn_error_message = prefix + "계정 정보를 확인하여 다시 로그인 해주세요.(" + user.user_id + ")"
              return
            }

            // JWT 로그인 시도 (SNS 사용자는 비밀번호가 없으므로 sns_id를 비밀번호로 사용)
            try {
              const jwtResponse = await this.login({
                user_id: user.user_id,
                password: userResp.data.sub, // Google sub를 비밀번호로 사용
              })

              if (jwtResponse.success) {
                // QR 코드 업데이트
                try {
                  if (state && state.qrcode) {
                    await authService.updateQrCode(user.user_id, state.qrcode)
                  }
                } catch (e) {
                  console.log(e)
                  alert(this.$t("alert.error_failed_qrocde_authentication"))
                  this.$router.replace("/auth/login")
                  return
                }

                // 기존 Vuex mutation도 호출 (하위 호환)
                // sns_profile_image를 별도로 저장하여 새로고침 시에도 유지
                this.$store.commit("login", {
                  ...user,
                  sns_profile_image: userResp.data.picture,
                  type: "SNS",
                })
                this.$gtag.event("login", { method: "Google" })

                // 리다이렉트 처리
                this.$router.replace(createTravelerLoginDestination(state))
              }
            } catch (jwtError) {
              console.error("JWT 로그인 실패:", jwtError)
              // JWT 실패 시 기존 방식으로 폴백
              // sns_profile_image를 별도로 저장하여 새로고침 시에도 유지
              this.$store.commit("login", {
                ...user,
                sns_profile_image: userResp.data.picture,
                type: "SNS",
              })
              this.$gtag.event("login", { method: "Google" })
              this.$router.replace(createTravelerLoginDestination(state))
            }
          }
        } else {
          alert("구글 로그인 정보를 가져오지 못해 인증에 실패하였습니다.")
          this.$router.replace("/auth/login")
        }
      } catch (e) {
        console.log(e)
        alert("인증 및 가입에 실패하였습니다.")
        this.$router.replace("/auth/login")
      }
    }, // end googleLogin

    // sns 인증 다음 화면으로 이동
    next_register: _.debounce(async function () {
      let state = null
      if (this.$route.query.state) {
        state = JSON.parse(decodeURIComponent(atob(this.$route.query.state)))
      }
      console.log("state", state)

      this.$router.push({
        path: "/auth/join/agree",
        query: state || {},
      })
    }, 500),

    loginCancle() {
      this.$router.back()
      //this.show_warn_dialog = false
      //this.show_confirm_dialog = false
    },
  },
}
</script>
